import styles from "./ReplaceInfo.module.scss";
import useLazyVideo from "../../../utils/hooks/useLazyVideo";

const ReplaceInfo = ({ dictionary }) => {
	const [containerRef, videoRef, isInView] = useLazyVideo();

	return (
		<section className={styles.container} ref={containerRef}>
			<div className={styles.text}>
				<h2 className={styles.title}>{dictionary["page_erase_header_replace"]}</h2>
				<p className={styles.description}>
					{dictionary["page_erase_description_replace_first"]}
					<br />
					{dictionary["page_erase_description_replace_second"]}
				</p>
			</div>
			<video ref={videoRef} className={styles.video} autoPlay={isInView} loop muted playsInline preload="none" poster="/erase_and_replace/replace_info/1.webp">
				<source src="/video/erase_ring.mp4" type="video/mp4" />
			</video>
		</section>
	);
};

export default ReplaceInfo;
